<template>
  <div class="">
    <div class="se-m-b-20">
      <breadcrumb></breadcrumb>
    </div>
    <el-tabs v-model="activeName" @tab-click="tabsChange">
      <el-tab-pane
        :label="type === 'course' ? `课程(${pageInfo.total})` : '用户管理'"
        name="first"
      >
        <div class="se-list">
          <div
            class="se-item pos-r se-m-b-20"
            v-for="(item, i) in list"
            :key="i"
            @click="goInfo(item)"
          >
            <course-item :item="item"></course-item>
            <img
              v-if="item.isExcellent"
              src="../../assets/icons/youxiu.png"
              class="se-img-tj"
              style="width: 63px; height: 28px"
            />
            <img
              v-if="
                (item.isHighQuality && item.isExcellent) || item.isHighQuality
              "
              src="../../assets/icons/jingpin.png"
              class="se-img-tj"
              style="width: 63px; height: 28px"
            />
          </div>
        </div>
        <div class="se-flex-h-c">
          <el-pagination
            background
            :current-page="pageInfo.page"
            :page-size="pageInfo.size"
            layout="prev, pager, next, jumper"
            :total="pageInfo.total"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import courseItem from "../components/courseItem.vue";
import breadcrumb from "../components/breadCrumb.vue";

export default {
  components: {
    courseItem,
    breadcrumb,
  },

  data() {
    return {
      list: [],
      pageInfo: {
        size: 12,
        page: 1,
        total: 0,
      },
      activeName: "first",
      currentPage: 1,
      browseList: [],
      type: "",
      txt: "",
      courseSort: "",
      childSort: "",
      total: 0,
    };
  },
  watch: {
    "$route.query.t"() {
      if (this.type === "course") {
        this.courseInfo();
      }
    },
  },
  created() {
    const { type } = this.$route.query;
    if (type === "course") {
      this.courseInfo();
    } else {
      this.getBrowseList();
    }
  },
  methods: {
    courseInfo() {
      const { type, txt, courseSort, childSort } = this.$route.query;
      this.type = type;
      this.txt = txt;
      this.courseSort = courseSort;
      this.childSort = childSort;
      this.getCourse();
    },
    async getCourse() {
      const data = {
        pageSize: this.pageInfo.size,
        pageNum: this.pageInfo.page,
        str: this.txt,
      };
      if (this.childSort) {
        data.sepcialty = this.childSort;
      } else {
        // if (this.courseSort) {
        //   data.prentSepcialty = this.courseSort;
        // }
      }
      this.$http.get("server/portal/home/listCourse", data).then((res) => {
        if (res.code == 200) {
          this.list = res.rows;
          this.pageInfo.total = res.total;
        }
      });
    },

    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getCourse();
    },

    //   标签页回调
    tabsChange(e) {
      // console.log(e);
    },

    // 分页回调
    currentChange(e) {
      // console.log(e);
    },

    // 去课程详情
    goInfo(item) {
      this.$router.push({
        name: "courseInfo",
        query: {
          type: "course",
          courseId: item.courseId,
          teacherId: item.teacherId,
          t: new Date().getTime(),
        },
      });
    },

    //获取浏览记录
    getBrowseList() {
      let token = localStorage.getItem("token");
      this.$http
        .get(
          "/server/portal/personCenter/browseRecordList",
          {},
          {
            headers: {
              // "Content-Type":"application/json"
              Authorization: "Bearer " + token,
            },
          }
        )
        .then((res) => {
          if (res.code == 200) {
            this.browseList = res.rows;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__nav-wrap::after {
  background-color: #e4e4e4;
}

/deep/ .el-tabs__item.is-active {
  color: #e44352;
}

/deep/ .el-tabs__active-bar {
  background-color: #e44352;
}

/deep/ .el-tabs__item:hover {
  color: #e44352;
}

.se-list {
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
}

.se-item {
  margin-right: 30px;
  width: calc((100% - 90px) / 4);
  background-color: #fff;
  border-radius: 10px;
  &:nth-child(4n) {
    margin-right: 0;
  }
  > div {
    height: 100%;
  }
}

.se-img-tj {
  position: absolute;
  right: 0;
  top: -1px;
}
</style>
